import { CompetenceType } from "./modules/competence/components/competenceDetails/competenceDetails.constants";
import { StatisticsTheme } from "./modules/teamIndicators/views/statistics/statistics.constants";
import { DisabledItemTheme, GamificationTheme } from "./app/mainNavigation/components/navItem.constants";
import { AvatarTheme } from "./components/avatar/avatar.constants";
import { TagFilteringTheme } from "./components/competenceTagFiltersList/competenceTagFiltersList.constants";
import { IDDFilterTheme } from "./modules/knowledgeBase/components/filters/filters.constants";
import { CareerTheme } from "./modules/profile/profile.constants";
import { CookieName } from "./app/cookiePopup/cookiePopup.constants";
import { BrandTheme } from "./appSettings/brandReset/brandReset.constants";
import { Module } from "./modules/modules.constants";
import { TrainingPhoneLength } from "./modules/trainings/trainings.constants";
import { ProfileEditTheme } from "./modules/profile/components/editForm/editForm.constants";
import { OnboardingAllMode } from "./modules/onboarding/onboarding.constants";
import { TutorialStatus } from "./components/tutorialPopup/tutorialPopup.constants";
import { LanguageTheme } from "./translations/i18n.constants";
import { Color } from "./theme/colors";
import { isCookieEnabled } from "./helpers/isCookieEnabled";

export const locationObject = (typeof window !== "undefined") ? window.location : {};

const Domain = locationObject.hostname ? locationObject.hostname.replace("www.", "") : "";

const nodeDomain = (typeof window !== "undefined") ? window.NODE_API_DOMAIN : "";

export const AppConfig = {
  nodeApi: process.env.REACT_APP_NODE_API_DOMAIN
    ? `https://${process.env.REACT_APP_NODE_API_DOMAIN}/api`
    : nodeDomain !== ""
      ? `${locationObject.protocol}//${nodeDomain}/api`
      : `${locationObject.protocol}//node.${Domain}/api`,
  api: process.env.REACT_APP_PHP_API_DOMAIN
    ? `https://${process.env.REACT_APP_PHP_API_DOMAIN}`
    : locationObject.origin,
  content: process.env.REACT_APP_NODE_API_DOMAIN
    ? `https://${process.env.REACT_APP_NODE_API_DOMAIN}`
    : nodeDomain !== ""
      ? `${locationObject.protocol}//${nodeDomain}`
      : `${locationObject.protocol}//node.${Domain}`,
  webservice: process.env.REACT_APP_NODE_API_DOMAIN
    ? `wss://${process.env.REACT_APP_NODE_API_DOMAIN}`
    : nodeDomain !== ""
      ? `wss://${nodeDomain}`
      : `wss://node.${Domain}`,
  encryptMode: process.env.REACT_APP_ENCRYPT_MODE
    ? process.env.REACT_APP_ENCRYPT_MODE
    : true,
  platformContactEmail: process.env.REACT_APP_PLATFORM_CONTACT_EMAIL
    ? process.env.REACT_APP_PLATFORM_CONTACT_EMAIL
    : "kontakt@vwbank-szkolenia.pl",
  platformName: process.env.REACT_APP_PLATFORM_NAME
    ? process.env.REACT_APP_PLATFORM_NAME
    : "Volkswagen Financial Services",
  GA_id: (process.env.REACT_APP_GA_ID && isCookieEnabled(CookieName.Analytical))
    ? process.env.REACT_APP_GA_ID
    : (typeof window !== "undefined" && isCookieEnabled(CookieName.Analytical)) ? window.GA_ID : "",
  reCaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY
    ? process.env.REACT_APP_RECAPTCHA_KEY
    : (typeof window !== "undefined") ? window.RECAPTCHA_KEY : "",
  reCaptchaEnabled: process.env.REACT_APP_RECAPTCHA_ENABLED === "true"
    ? process.env.REACT_APP_RECAPTCHA_ENABLED
    : (typeof window !== "undefined") ? window.RECAPTCHA_ENABLED === "1" : false,
  logsSystemClientToken: process.env.REACT_APP_EXTERNAL_LOGGER_CLIENT_TOKEN
    ? process.env.REACT_APP_EXTERNAL_LOGGER_CLIENT_TOKEN
    : (typeof window !== "undefined") ? window.EXTERNAL_LOGGER_CLIENT_TOKEN : "",
  ownDeployment: process.env.REACT_APP_OWN_DEPLOYMENT === "true",
  incomingAuthViewToken: process.env.REACT_APP_INCOMING_AUTH_VIEW_TOKEN,
  socials: {
    fb: process.env.REACT_APP_FB_URL
      ? process.env.REACT_APP_FB_URL
      : "",
    yt: process.env.REACT_APP_YT_URL
      ? process.env.REACT_APP_YT_URL
      : "",
    instagram: process.env.REACT_APP_INSTAGRAM_URL
      ? process.env.REACT_APP_INSTAGRAM_URL
      : "",
    pin: process.env.REACT_APP_PIN_URL
      ? process.env.REACT_APP_PIN_URL
      : "",
    snapchat: process.env.REACT_APP_SNAPCHAT_URL
      ? process.env.REACT_APP_SNAPCHAT_URL
      : "",
    twitter: process.env.REACT_APP_TWITTER_URL
      ? process.env.REACT_APP_TWITTER_URL
      : "",
  },
  modules: [
    Module.Dashboard,
    Module.News,
    Module.KnowledgeBase,
    Module.Idd,
    Module.Trainings,
    Module.Training,
    Module.Onboarding,
    Module.VideoPlayer,
    Module.Notifications,
    Module.Surveys,
    Module.Competence,
    Module.TeamIndicators,
    Module.Gamification,
    Module.Certificates,
    Module.Profile,
    Module.ScrollLesson,
    Module.AnonSurvey,
    Module.Form,
  ],
  timelineEnabled: process.env.REACT_APP_VIDEO_TIMELINE_ENABLED === "true",
  errorHandlingEnabled: true,
  contentLocalOverrides: {},
};

export const Theme = {
  Avatar: AvatarTheme.Initials,
  DisabledMenuItems: DisabledItemTheme.Locked,
  IDDFilter: IDDFilterTheme.Visible,
  StatisticsTheme: StatisticsTheme.Hidden,
  CareerTheme: CareerTheme.Visible,
  CompetenceTagFiltering: TagFilteringTheme.Hidden,
  Brand: BrandTheme.Changeable,
  CompetenceType: CompetenceType.Specialized,
  TrainingPhoneLength: TrainingPhoneLength.Long,
  ProfileEdit: ProfileEditTheme.WithCompany,
  Gamification: GamificationTheme.Ambassador,
  RegistrationColorTheme: Color.blue5,
  OnboardingWithDuties: true,
  OnboardingAll: OnboardingAllMode.Enabled,
  NewPasswordRemind: false,
  Tutorial: TutorialStatus.Disabled,
  Language: LanguageTheme.PL,
  ModernEmailVerification: true,
  ModernFooter: false,
  ModernNavigation: false,
  ModernScrollLesson: false,
  ReCaptchaOnSignInEnabled: true,
  ModernInteractions: false,
  ModernTestsAndForms: false,
  UsersAdministration: false,
  // TODO: move to be functionality
  ComparisonTableEnabled: false,
};
